import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FakturniaHorizontalNavigationComponent } from '@fakturnia/components/navigation/horizontal/horizontal.component';
import { FakturniaNavigationItem } from '@fakturnia/components/navigation/navigation.types';
import { NavigationService } from 'shared/services/navigation.service';
import { Subject, Subscription, takeUntil, take } from 'rxjs';
import { FakturniaFullscreenComponent } from '@fakturnia/components/fullscreen/fullscreen.component';
import { UserComponent } from '@fakturnia/components/user/user.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SynchronizationService } from 'shared/services/synchronization.service';
import { AuthService } from 'shared/services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MediaWatcherService } from 'shared/services/media-watcher.service';
import { FakturniaNavigationService, FakturniaVerticalNavigationComponent } from '@fakturnia/components/navigation';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsBellComponent } from 'shared/components/notifications-bell/notifications-bell.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { GuidedTourService } from 'shared/services/guided-tour.service';
import { KsefTokenDialogComponent } from 'shared/dialogs/ksef-token-dialog/ksef-token-dialog.component';

@Component({
  selector: 'modern-layout',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterOutlet, MatTooltipModule, FakturniaVerticalNavigationComponent, FakturniaHorizontalNavigationComponent, UserComponent, MatProgressBarModule, FakturniaFullscreenComponent, RouterModule, MatIconModule, NotificationsBellComponent, MatMenuModule],
  templateUrl: './modern-layout.component.html',
  styleUrl: './modern-layout.component.scss'
})
export class ModernLayoutComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  public isScreenSmall: boolean;
  public navigation: FakturniaNavigationItem[] = []
  public isSynchronizing = false
  public isLoggedIn = false

  constructor(
    private _cdr: ChangeDetectorRef,
    private _navigationService: NavigationService,
    private _synchronizationService: SynchronizationService,
    private _authService: AuthService,
    private _mediaWatcherService: MediaWatcherService,
    private _fakturniaNavigationService: FakturniaNavigationService,
    private _guidedTourService: GuidedTourService,
    private _dialog: MatDialog
  ) {




  }

  /**
    * Toggle navigation
    *
    * @param name
    */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation = this._fakturniaNavigationService.getComponent<FakturniaVerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }

  /** Uruchamia przewodnik ponownie z menu pomocy */
  startGuidedTour(): void {
    this._guidedTourService.connectKsef$.pipe(take(1)).subscribe(() => {
      this._dialog.open(KsefTokenDialogComponent, {
        maxWidth: '1100px',
        width: '95vw',
        maxHeight: '90vh'
      });
    });

    setTimeout(() => {
      this._guidedTourService.start();
    }, 300);
  }

  ngOnInit(): void {

    this._navigationService.currentNavigation
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (navigation) => {
          this.navigation = navigation
        }
      })


    this._authService.isLoggedIn$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (data) => {
        this.isLoggedIn = data
        this._cdr.markForCheck()
      }
    })

    // Subscribe to media changes
    this._mediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    this._synchronizationService.currentSynchronizationStatus
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data) => {
          if (!data.isSynchronizing) {
            setTimeout(() => {
              this.isSynchronizing = false
              this._cdr.markForCheck()
            }, 1500)
          }
          else {
            setTimeout(() => {
              this.isSynchronizing = true
              this._cdr.markForCheck()
            }, 10)
          }
        }
      })
  }

  ngOnDestroy(): void {

    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
